import { LogIn, LoaderCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { JapaReader } from "./app/JapaReader";
import { PwaInstallPrompt } from "./app/PwaInstallPrompt";
import { cloudIsConfigured, initializeAuth, signInWithGoogle, signOut, type AuthUser } from "./auth";

export function App() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    void initializeAuth()
      .then(setUser)
      .catch((reason) => setError(reason instanceof Error ? reason.message : "Não foi possível iniciar sua sessão."))
      .finally(() => setReady(true));
  }, []);

  if (!ready) {
    return <><main className="auth-screen"><LoaderCircle className="spin" size={28} /><span>Preparando sua biblioteca…</span></main><PwaInstallPrompt /></>;
  }

  if (!user) {
    return (
      <><main className="auth-screen">
        <section className="auth-card">
          <span className="auth-brand" aria-hidden="true">読</span>
          <span className="eyebrow">JAPA READER</span>
          <h1>Seu livro, sua voz, seu ritmo.</h1>
          <p>Entre com o Google para manter livros, áudios, alinhamentos e progresso sincronizados com segurança.</p>
          {error && <div className="form-error" role="alert">{error}</div>}
          {cloudIsConfigured() ? (
            <button className="google-button" onClick={() => void signInWithGoogle().catch((reason) => setError(reason.message))}>
              <LogIn size={18} /> Continuar com Google
            </button>
          ) : (
            <div className="auth-config-warning">A configuração AWS deste ambiente ainda não foi aplicada.</div>
          )}
        </section>
      </main><PwaInstallPrompt /></>
    );
  }

  return <><JapaReader user={user} onSignOut={signOut} /><PwaInstallPrompt /></>;
}
